import { createFileRoute } from "@tanstack/react-router"
import { Privacy } from "./-PrivacyPage"

export const Route = createFileRoute("/privacy")({
  component: Privacy,
})
